import { useParams } from 'react-router-dom';

function useRouteRefParams(_routeRef) {
  return useParams();
}

export { useRouteRefParams };
//# sourceMappingURL=useRouteRefParams.esm.js.map
